module.exports = __webpack_public_path__ + "static/img/americanExpress.dc563cf.png";